import { InjectionToken } from '@angular/core';

import type { Redactor, RedactorConfig } from '../redactor.types';

declare const $R: Redactor;

export const REDACTOR_EXTENSIONS = new InjectionToken('REDACTOR_EXTENSIONS');

export abstract class RedactorExtension {
  public get enabled(): boolean {
    return this._enabled;
  }
  protected _enabled: boolean = false;

  public abstract canInstall(config: RedactorConfig): boolean;
  public abstract install(config: RedactorConfig): RedactorConfig;

  protected enable(): void {
    this._enabled = true;
  }
}
export const mergeRedactorConfigArrField = (
  cfg: RedactorConfig,
  key: keyof RedactorConfig,
  next: string[],
  defaults = true,
) => {
  const prev = cfg[key];
  return Array.from(
    new Set(
      Array.isArray(prev)
        ? [...next, ...prev]
        : [...next, ...(prev ? [prev] : defaults ? $R.opts[key] : [])],
    ),
  );
};
